import React from 'react'

import { UserContext } from '../context'

const UserContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const contextValue = {}

  return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
}

export { UserContextProvider }
